import { deleteTracklistBookmark, postTracklistBookmark } from "@api/bookmarks";
import { deleteTrackListLike, postTrackListLike } from "@api/tracklists";
import type { Tracklist } from "@api/tracklists/types";

const useProgramme = () => {
	const updateBookmark = (tracklist: Tracklist) => {
		if (tracklist.bookmarked) return deleteTracklistBookmark(tracklist.uuid);
		return postTracklistBookmark(tracklist.uuid);
	};
	const updateLike = (tracklist: Tracklist) => {
		if (tracklist.liked) return deleteTrackListLike(tracklist.uuid);
		return postTrackListLike(tracklist.uuid);
	};

	return { updateBookmark, updateLike };
};
export default useProgramme;
